module.exports = __webpack_public_path__ + "399ec9df3e9fa41240beaf4ecf28ca9b.svg";